/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum SaeLocatorAliases {
  DESCRIPTION_FIELD = 'description-field',
  DESCRIPTION_INPUT = 'description-input',
  GLOBAL_ACTIONS_0 = 'global-actions-0',
  ID_FIELD = 'id-field',
  ID_INPUT = 'id-input',
  LOCATOR_SAE_LAYOUT = 'locator-sae-layout',
  MAIN_CONTEXTUAL_BAR = 'main-contextual-bar',
  SAE_CARD = 'sae-card',
  SAE_DECK = 'sae-deck',
  SAE_FETCH_MOBILE = 'sae-fetch-mobile',
  SAE_FILTER = 'sae-filter',
  SAE_FILTERED_LIST = 'sae-filtered-list',
  SAE_MAPPER = 'sae-mapper',
  SAE_PANEL = 'sae-panel',
  SAE_TEXT = 'sae-text',
  SELECT_BUTTON = 'select-button',
}
export { SaeLocatorAliases };
